import * as constants from './constants';
import { pressToTalkSlice } from './slice';

export default { constants, pressToTalkSlice };
